import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { DashboardService } from "./dashboard.service";
import { HttpErrorResponse } from "@angular/common/http";
import { catchError, switchMap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class GeminiSessionService {
    constructor(private dashboardService: DashboardService) { }

    GetSessionGeminiNumber(): Observable<number | null> {
        const userGeminiNumber = sessionStorage.getItem("UserGeminiNumber");

        if (userGeminiNumber !== null) {
            return of(parseInt(userGeminiNumber));
        }
        else {
            return this.dashboardService.GetGeminiNumber().pipe(
                switchMap((data: any) => {
                    sessionStorage.setItem('UserGeminiNumber', data);
                    return of(parseInt(data));
                }),
                catchError((err: HttpErrorResponse) => {
                    return of(null);
                })
            );
        }
    }

    handleExternalNavigation(url: string): void {
        if (!url) {
            return;
        }

        const userAgent = navigator.userAgent;
        const isSafari =
            userAgent.includes('Safari') &&
            !userAgent.includes('Chrome') &&
            !userAgent.includes('CriOS');

        if (isSafari) {
            // Safari blocks some popups, so redirect in same tab
            window.location.href = url;
        }
        else {
            const newTab = window.open('', '_blank');
            if (newTab) {
                newTab.location.href = url;
            } else {
                window.location.href = url;
            }
        }
    }

}
